package com.ervasstudio.tracoemovimento.model

enum class NewsState { INVITATION, FORM, LOADING, SUCCESS }